import React from 'react'
import { XStack, YStack } from 'tamagui'

import { H3, Paragraph } from '@newComponents/Text'

import { DocScreenshot } from './DocScreenshot'

export const DocStep = ({
  number,
  title,
  description,
  screenshot,
}: {
  number: number
  title: string
  description: string
  screenshot?: { src: string; alt: string; caption?: string }
}) => (
  <YStack gap='$3' paddingTop='$2'>
    <XStack gap='$3' alignItems='center'>
      <YStack
        width={28}
        height={28}
        borderRadius={14}
        backgroundColor='$backgroundAccent'
        alignItems='center'
        justifyContent='center'
        flexShrink={0}
      >
        <Paragraph size='$4' fontWeight='$7' color='$colorAccent'>
          {number}
        </Paragraph>
      </YStack>
      <H3>{title}</H3>
    </XStack>
    <Paragraph size='$5' color='$colorMuted'>
      {description}
    </Paragraph>
    {screenshot ? <DocScreenshot {...screenshot} /> : null}
  </YStack>
)
